import header from 'i18n/default/ro/header.json';
import mainMenu from 'i18n/default/ro/mainMenu';
import pendingPaymentAdvice from 'i18n/default/ro/pendingPaymentAdvice';
import PalletType from 'i18n/default/ro/PalletType';
import LiteralCurrency from 'i18n/default/ro/LiteralCurrency';
import units from 'i18n/default/ro/units';
import CustomPalletSize from 'i18n/default/ro/CustomPalletSize';
import NumberOfItems from 'i18n/default/ro/NumberOfItems';
import LoadInfo from 'i18n/default/ro/LoadInfo';
import LoadInputs from 'i18n/default/ro/LoadInputs';
import dates from 'i18n/default/ro/dates';
import Addresses from 'i18n/default/ro/Addresses';
import AddressFormModal from 'i18n/default/ro/AddressFormModal';
import AddressSelector from 'i18n/default/ro/AddressSelector';
import StopAddress from 'i18n/default/ro/StopAddress';
import Quote from 'i18n/default/ro/Quote';
import extraNames from 'i18n/default/ro/extraNames';
import timePickers from 'i18n/default/ro/timePickers';
import authLoginForm from 'i18n/default/ro/authLoginForm';
import authSignUpForm from 'i18n/default/ro/authSignUpForm';
import HandlingExtra from 'i18n/default/ro/HandlingExtra';
import Stop from 'i18n/default/ro/Stop';
import VehicleExtras from 'i18n/default/ro/VehicleExtras';
import OrderStop from 'i18n/default/ro/OrderStop';
import ShipmentCard from 'i18n/default/ro/ShipmentCard';
import Orders from 'i18n/default/ro/Orders';
import Summary from 'i18n/default/ro/Summary';
import Login from 'i18n/default/ro/Login';
import AddressesPage from 'i18n/default/ro/AddressesPage';
import ModalSummary from 'i18n/default/ro/ModalSummary';
import OrderSummary from 'i18n/default/ro/OrderSummary';
import OrdersOrderDetail from 'i18n/default/ro/OrdersOrderDetail';
import Order from 'i18n/default/ro/Order';
import ModalOrderDetail from 'i18n/default/ro/ModalOrderDetail';
import loads from 'i18n/default/ro/loads';
import SuggestedTimes from 'i18n/default/ro/SuggestedTimes';
import Downloads from 'i18n/default/ro/Downloads';
import CreditCard from 'i18n/default/ro/CreditCard';
import TypeOfOrderSelector from 'i18n/default/ro/TypeOfOrderSelector';
import Recurring from 'i18n/default/ro/Recurring';
import Settings from 'i18n/default/ro/Settings';
import InviteUserModal from 'i18n/default/ro/InviteUserModal';
import PaymentData from 'i18n/default/ro/PaymentData';
import DriverMapError from 'i18n/default/ro/DriverMapError';
import Faqs from 'i18n/default/ro/Faqs';
import AdditionalDocuments from 'i18n/default/ro/AdditionalDocuments';
import Communications from 'i18n/default/ro/Communications';
import RecurringOrderSuggestions from 'i18n/default/ro/RecurringOrderSuggestions';
import Error from 'i18n/default/ro/Error';
import Users from 'i18n/default/ro/Users';
import Tracking from 'i18n/default/ro/Tracking';
import Dashboard from 'i18n/default/ro/Dashboard';
import Catalog from 'i18n/default/ro/Catalog';
import Emergencies from 'i18n/default/ro/Emergencies';
import SignUp from 'i18n/default/ro/SignUp';
import Profile from 'i18n/default/ro/Profile';
import Landing from 'i18n/default/ro/Landing';

const lang = {
  Emergencies,
  Catalog,
  header,
  mainMenu,
  pendingPaymentAdvice,
  PalletType,
  LiteralCurrency,
  units,
  CustomPalletSize,
  NumberOfItems,
  LoadInfo,
  LoadInputs,
  dates,
  AddressFormModal,
  AddressSelector,
  StopAddress,
  Quote,
  extraNames,
  timePickers,
  authLoginForm,
  authSignUpForm,
  HandlingExtra,
  Stop,
  VehicleExtras,
  OrderStop,
  ShipmentCard,
  Orders,
  Summary,
  Login,
  AddressesPage,
  OrdersOrderDetail,
  ModalSummary,
  OrderSummary,
  Order,
  ModalOrderDetail,
  loads,
  SuggestedTimes,
  Downloads,
  CreditCard,
  Addresses,
  TypeOfOrderSelector,
  Recurring,
  Settings,
  InviteUserModal,
  PaymentData,
  DriverMapError,
  Faqs,
  AdditionalDocuments,
  Communications,
  RecurringOrderSuggestions,
  Error,
  Users,
  Tracking,
  Dashboard,
  SignUp,
  Profile,
  Landing
};

export default lang;
